module.exports = __webpack_public_path__ + "img/ic_password_inactive.acf62e84.svg";